import { makeModuleStateSelector } from "@client/content/selectors";
import { createShallowEqualSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { defaultState, previewState } from "./reducer";
import { type BlogDetailHeader } from "./types";

export const localStateSelector = makeModuleStateSelector<BlogDetailHeader.State>(defaultState, previewState);

export const makePostSettingsSelector = () => {
  const titlePositionSelector = getSettingValueSelector(TargetSelector.Entity, "position", "title");

  return createShallowEqualSelector(
    [titlePositionSelector],
    (titlePosition): BlogDetailHeader.View.PostSettings => ({
      titlePosition
    })
  );
};
